/* lua.js generated code 0.3.0 */

PushBounceAnim = xClass("PushBounceAnim")

PushBounceAnim.create = function (button, animNode, minScale, maxScale) {
    return PushBounceAnim.new.call(this, button, animNode, minScale, maxScale)
}
PushBounceAnim.prototype.ctor = function (button, animNode, minScale, maxScale) {
    var self = this
    self.downHandler = null
    self.moveInHander = null
    self.moveOutHandler = null
    self.upHandler = null
    self.upOutHandler = null
    self.button = button
    self.animNode = animNode || self.button
    self.animNode.pushBounceAnimInstance = self
    self.scaleX = self.animNode.getScaleX()
    self.scaleY = self.animNode.getScaleY()
    self.minScale = minScale || 0.85
    self.maxScale = maxScale || 1.1
    self.useAnim()
}
PushBounceAnim.prototype.updateScale = function () {
    let self = this
    self.scaleX = self.animNode.getScaleX()
    self.scaleY = self.animNode.getScaleY()
}
PushBounceAnim.prototype.useAnim = function () {
    var self = this
    var listening = false
    function onBounceEnable() {
        cc.log("&&&&&&&&&&&&&&&&&&&&onBounceEnable&&&&&&&&&&&&&&&&&&&&&&&&&")
        if (listening) {
            return 
        }
        listening = true
        if (self.button.ignoreAnim && self.button.ignoreAnim === 1) {
            return 
        }
        self.animNode.runAction(cc.ScaleTo.create(0.05, self.minScale * self.scaleX, self.minScale * self.scaleY))
    }
    function onBounceDisable() {
        cc.log("&&&&&&&&&&&&&&&&&&&&onBounceDisable&&&&&&&&&&&&&&&&&&&&&&&&&")
        if (!listening) {
            return 
        }
        listening = false
        if (self.button.ignoreAnim && self.button.ignoreAnim === 1) {
            return 
        }
        self.animNode.runAction(cc.Sequence.create(cc.ScaleTo.create(0.1, self.scaleX * self.maxScale, self.scaleY * self.maxScale), cc.ScaleTo.create(0.08, self.scaleX, self.scaleY)))
    }
    var useless
    [useless, self.downHandler] = self.button.on(UIButtonEvent.Down, onBounceEnable)
    [useless, self.moveInHander] = self.button.on(UIButtonEvent.MoveIn, onBounceEnable)
    [useless, self.upHandler] = self.button.on(UIButtonEvent.Click, onBounceDisable)
    [useless, self.moveOutHandler] = self.button.on(UIButtonEvent.MoveOut, onBounceDisable)
    [useless, self.upOutHandler] = self.button.on(UIButtonEvent.UpOutside, onBounceDisable)
}
PushBounceAnim.prototype.removeAnim = function () {
    var self = this
    self.button.removeEventListener(self.downHandler)
    self.button.removeEventListener(self.moveInHander)
    self.button.removeEventListener(self.moveOutHandler)
    self.button.removeEventListener(self.upHandler)
    self.button.removeEventListener(self.upOutHandler)
}
module.exports = PushBounceAnim
